var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLaptopMedical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_laptop-medical",
    "data-name": "Icon - laptop-medical",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 20,
    viewBox: "0 0 26.667 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "laptop-medical",
    d: "M26,46H24V34.667A2.67,2.67,0,0,0,21.333,32h-16a2.67,2.67,0,0,0-2.667,2.667V46h-2A.667.667,0,0,0,0,46.667v2A3.337,3.337,0,0,0,3.333,52h20a3.337,3.337,0,0,0,3.333-3.333v-2A.667.667,0,0,0,26,46ZM4,34.667a1.333,1.333,0,0,1,1.333-1.333h16a1.333,1.333,0,0,1,1.333,1.333V46H16.3a.35.35,0,0,0-.33.3,1.333,1.333,0,0,1-1.3,1.038H12A1.333,1.333,0,0,1,10.7,46.3a.348.348,0,0,0-.33-.3H4Zm21.333,14a2,2,0,0,1-2,2h-20a2,2,0,0,1-2-2V47.333H9.448a2,2,0,0,0,1.885,1.333h4a2,2,0,0,0,1.885-1.333h8.115ZM12,43.667a.333.333,0,0,0,.333.333h2a.333.333,0,0,0,.333-.333V41.333H17A.333.333,0,0,0,17.333,41V39A.333.333,0,0,0,17,38.667H14.667V36.333A.333.333,0,0,0,14.333,36h-2a.333.333,0,0,0-.333.333v2.333H9.667A.333.333,0,0,0,9.333,39v2a.333.333,0,0,0,.333.333H12Z",
    transform: "translate(0 -32)",
    fill: "#0078c9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLaptopMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - laptop-medical.39eb3036d07c4536039ab43ea029a280.svg";